// import React, { useEffect, useState } from 'react';
// import { useParams } from "react-router-dom";
// import { getWithTokenAPI, putAPI } from '../../utils/Api';
// import { useNavigate } from "react-router-dom";

// import {
//   TextField,
//   Typography,
//   Checkbox,
//   Button,
//   Box,
//   Paper,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Select
// } from '@mui/material';
// import { toast } from "react-toastify";

// const Editrolepage = () => {
//   const { id } = useParams();
//   const [roleData, setRoleData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   const [modules, setModules] = useState([
//     {
//       name: 'User',
//       permissions: {
//         view: false,
//         create: null,
//         update: null,
//         delete: null,
//       }
//     },
//     {
//       name: 'Seller',
//       permissions: {
//         view: false,
//         create: false,
//         update: false,
//         delete: null,
//       }
//     },
//     {
//       name: 'Category',
//       permissions: {
//         view: false,
//         create: false,
//         update: false,
//         delete: null,
//       }
//     },
//     {
//       name: 'Product',
//       permissions: {
//         view: false,
//         create: false,
//         update: false,
//         delete: null,
//       }
//     },
//     {
//       name: 'Order',
//       permissions: {
//         view: false,
//         create: null,
//         update: null,
//         delete: null,
//       }
//     },
//     {
//       name: 'Blog',
//       permissions: {
//         view: false,
//         create: false,
//         update: false,
//         delete: false,
//       }
//     },
//     {
//       name: 'Drone',
//       permissions: {
//         view: false,
//         create: null,
//         update: false,
//         delete: null,
//       }
//     },
//     {
//       name: 'Soiltest',
//       permissions: {
//         view: false,
//         create: null,
//         update: false,
//         delete: null,
//       }
//     },
//     {
//       name: 'Farmdata',
//       permissions: {
//         view: false,
//         create: null,
//         update: null,
//         delete: null,
//       }
//     },
//     {
//       name: 'Role',
//       permissions: {
//         view: false,
//         create: false,
//         update: false,
//         delete: false,
//       }
//     },
//     {
//       name: 'Resource',
//       permissions: {
//         view: false,
//         create: false,
//         update: null,
//         delete: false,
//       }
//     },
//     {
//       name: 'Newsletter',
//       permissions: {
//         view: false,
//         create: null,
//         update: null,
//         delete: null,
//       }
//     },
//     {
//       name: 'Enquiries',
//       permissions: {
//         view: false,
//         create: null,
//         update: null,
//         delete: null,
//       }
//     },
//     {
//       name: 'Wishlist',
//       permissions: {
//         view: false,
//         create: null,
//         update: null,
//         delete: null,
//       }
//     },
//     {
//       name: 'Cart',
//       permissions: {
//         view: false,
//         create: null,
//         update: null,
//         delete: null,
//       }
//     },
//     {
//       name: 'Revenue',
//       permissions: {
//         view: false,
//         create: null,
//         update: null,
//         delete: null,
//       }
//     },
//      {
//       name: 'subscription',
//       permissions: {
//         view: false,
//         create: null,
//         update: null,
//         delete: null,
//       }
//     },
//      {
//       name: 'Dronemanagement',
//       permissions: {
//         view: false,
//         create: false,
//         update: null,
//         delete: false,
//       }
//     },
 
//   ]);

//   useEffect(() => {
//     const fetchData = async () => {
//       const token = localStorage.getItem("token");
//       try {
//         const res = await getWithTokenAPI(token, `/rolemanagement/find-particular?_id=${id}`);
//         setRoleData(res.data);

//         if (res.data && res.data.permissions) {
//           const updatedModules = modules.map(module => {
//             const moduleKey = module.name.toLowerCase().replace(/\s+/g, '_');
//             const modulePermissions = { ...module.permissions };

//             Object.keys(modulePermissions).forEach(perm => {
//               modulePermissions[perm] = false;
//             });

//             res.data.permissions.forEach(permission => {
//               const [perm, mod] = permission.split('_');
//               const normalizedMod = mod.replace(/\s+/g, '_'); // Normalize module name
//               if (normalizedMod === moduleKey && modulePermissions.hasOwnProperty(perm)) {
//                 modulePermissions[perm] = true;
//               }
//             });

//             return {
//               ...module,
//               permissions: modulePermissions
//             };
//           });
//           setModules(updatedModules);
//         }
//       } catch (error) {
//         console.error("Error fetching role:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [id]);

//   const handlePermissionChange = (moduleIndex, permission) => {
//     const updatedModules = [...modules];
//     updatedModules[moduleIndex].permissions[permission] =
//       !updatedModules[moduleIndex].permissions[permission];
//     setModules(updatedModules);
//   };

//   const handleSelectAll = (moduleIndex) => {
//     const updatedModules = [...modules];
//     const module = updatedModules[moduleIndex];
//     const allChecked = Object.values(module.permissions).every(Boolean);

//     Object.keys(module.permissions).forEach(perm => {
//       module.permissions[perm] = !allChecked;
//     });

//     setModules(updatedModules);
//   };

//   const handleSubmit = async () => {
//     const permissions = [];

//     modules.forEach(module => {
//       const moduleKey = module.name.toLowerCase().replace(/\s+/g, '_');
//       Object.entries(module.permissions).forEach(([perm, isEnabled]) => {
//         if (isEnabled) {
//           permissions.push(`${perm}_${moduleKey}`);
//         }
//       });
//     });

//     const updatedRoleData = {
//       ...roleData,
//       _id: id,
//       permissions: permissions
//     };
//     try {
//       const token = localStorage.getItem("token");
//       if (!token) {
//         throw new Error("No authentication token found");
//       }
//       const response = await putAPI(token, "/rolemanagement/update", updatedRoleData);
//       if (response?.statusCode === 200) {
//         toast.success("Role  updated successfully!")
//         navigate("/backoffice/rolemanagement")
//       } else {
//         toast.error("Failed to update Role ", response.message);
//       }
//     } catch (error) {
//       toast.error("Error updating role:", error);
//       if (error.response) {
//         toast.error("Server error:", error.response.status, error.response.data);
//       } else if (error.request) {
//         toast.error("No response received");
//       } else {
//         toast.error("Error:", error.message);
//       }
//     }

//   };
//   return (
//     <div>
//       {loading ? (
//         <p>Loading...</p>
//       ) : roleData ? (
//         <div>
//           <Paper elevation={3} sx={{ p: 3, maxWidth: 1200 }}>
//             <Typography variant="h5" gutterBottom>
//               Update Role
//             </Typography>

//             <TextField
//               value={roleData.role_name}
//               label="Role Name"
//               fullWidthn
//               onChange={(e) => {
//                 setRoleData(prev => ({
//                   ...prev,
//                   role_name: e.target.value
//                 }));
//               }}
//             />
//             <Typography variant="h6" sx={{ mb: 2, mt: 3 }}>
//               Module Access
//             </Typography>
//             <Box sx={{ overflowX: 'auto' }}>
//               <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                 <thead>
//                   <tr style={{ textTransform: "capitalize", backgroundColor: '#f5f5f5' }}>
//                     <th style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>Module</th>
//                     {modules[0]?.permissions && Object.keys(modules[0].permissions).map(perm => (
//                       <th key={perm} style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>
//                         {perm}
//                       </th>
//                     ))}
//                     <th style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>Select All</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {modules.map((module, moduleIndex) => (
//                     <tr key={moduleIndex} style={{ borderBottom: '1px solid #eee' }}>
//                       <td style={{ padding: '12px', fontWeight: '500' }}>{module.name}</td>
//                       {Object.keys(module.permissions).map((permission) => (
//                         <td key={permission} style={{ padding: '12px', textAlign: 'center' }}>
//                           <Checkbox
//                             checked={module.permissions[permission]}
//                             disabled={module.permissions[permission] === null}
//                             onChange={() => handlePermissionChange(moduleIndex, permission)}
//                             color="primary"
//                           />
//                         </td>
//                       ))}
//                       <td style={{ padding: '12px', textAlign: 'center' }}>
//                         <Checkbox
//                           checked={Object.values(module.permissions).every(Boolean)}
//                           onChange={() => handleSelectAll(moduleIndex)}
//                           style={{ color: "green" }}
//                           indeterminate={
//                             Object.values(module.permissions).some(Boolean) &&
//                             !Object.values(module.permissions).every(Boolean)
//                           }
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </Box>
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={handleSubmit}
//                 disabled={!roleData.role_name.trim()}
//               >
//                 Update Role
//               </Button>
//             </Box>
//           </Paper>
//         </div>
//       ) : (
//         <p>No data found.</p>
//       )}
//     </div>
//   );
// };

// export default Editrolepage;

import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { getWithTokenAPI, putAPI } from '../../utils/Api';
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Typography,
  Checkbox,
  Button,
  Box,
  Paper,
} from '@mui/material';
import { toast } from "react-toastify";
 
const Editrolepage = () => {
  const { id } = useParams();
  const [roleData, setRoleData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
 
  const [modules, setModules] = useState([
    {
      name: 'User',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Seller',
      permissions: {
        view: false,
        create: false,
        update: false,
        delete: null,
      }
    },
    {
      name: 'Category',
      permissions: {
        view: false,
        create: false,
        update: false,
        delete: null,
      }
    },
    {
      name: 'Product',
      permissions: {
        view: false,
        create: false,
        update: false,
        delete: null,
      }
    },
    {
      name: 'Order',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Blog',
      permissions: {
        view: false,
        create: false,
        update: false,
        delete: false,
      }
    },
    {
      name: 'Drone',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Soiltest',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Farmdata',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Role',
      permissions: {
        view: false,
        create: false,
        update: false,
        delete: false,
      }
    },
    {
      name: 'Resource',
      permissions: {
        view: false,
        create: false,
        update: null,
        delete: false,
      }
    },
    {
      name: 'Newsletter',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Enquiries',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Wishlist',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Cart',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Revenue',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
     {
      name: 'subscription',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
     {
      name: 'Dronemanagement',
      permissions: {
        view: false,
        create: false,
        update: null,
        delete: false,
      }
    },
  ]);
 
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      try {
        const res = await getWithTokenAPI(token, `/rolemanagement/find-particular?_id=${id}`);
        setRoleData(res.data);
 
        if (res.data && res.data.permissions) {
          const updatedModules = modules.map(module => {
            const moduleKey = module.name.toLowerCase().replace(/\s+/g, '_');
            const modulePermissions = { ...module.permissions };
 
            // Reset all permissions to false first
            Object.keys(modulePermissions).forEach(perm => {
              if (modulePermissions[perm] !== null) {
                modulePermissions[perm] = false;
              }
            });
 
            // Set permissions from API response
            res.data.permissions.forEach(permission => {
              const [perm, mod] = permission.split('_');
              const normalizedMod = mod.replace(/\s+/g, '_');
              if (normalizedMod === moduleKey && modulePermissions.hasOwnProperty(perm)) {
                modulePermissions[perm] = true;
              }
            });
 
            return {
              ...module,
              permissions: modulePermissions
            };
          });
          setModules(updatedModules);
        }
      } catch (error) {
        console.error("Error fetching role:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);
 
  const handlePermissionChange = (moduleIndex, permission) => {
    const updatedModules = [...modules];
    // Only allow changing if the permission is not null
    if (updatedModules[moduleIndex].permissions[permission] !== null) {
      updatedModules[moduleIndex].permissions[permission] =
        !updatedModules[moduleIndex].permissions[permission];
      setModules(updatedModules);
    }
  };
 
  const handleSelectAll = (moduleIndex) => {
    const updatedModules = [...modules];
    const module = updatedModules[moduleIndex];
   
    // Get only the permissions that are not null
    const controllablePermissions = Object.keys(module.permissions).filter(
      perm => module.permissions[perm] !== null
    );
 
    // Check if all controllable permissions are currently selected
    const allSelected = controllablePermissions.every(
      perm => module.permissions[perm] === true
    );
 
    // Toggle only the controllable permissions
    controllablePermissions.forEach(perm => {
      module.permissions[perm] = !allSelected;
    });
 
    setModules(updatedModules);
  };
 
  const handleSubmit = async () => {
    const permissions = [];
 
    modules.forEach(module => {
      const moduleKey = module.name.toLowerCase().replace(/\s+/g, '_');
      Object.entries(module.permissions).forEach(([perm, isEnabled]) => {
        if (isEnabled) {
          permissions.push(`${perm}_${moduleKey}`);
        }
      });
    });
 
    const updatedRoleData = {
      ...roleData,
      _id: id,
      permissions: permissions
    };
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No authentication token found");
      }
      const response = await putAPI(token, "/rolemanagement/update", updatedRoleData);
      if (response?.statusCode === 200) {
        toast.success("Role updated successfully!")
        navigate("/backoffice/rolemanagement")
      } else {
        toast.error("Failed to update Role ", response.message);
      }
    } catch (error) {
      toast.error("Error updating role:", error);
      if (error.response) {
        toast.error("Server error:", error.response.status, error.response.data);
      } else if (error.request) {
        toast.error("No response received");
      } else {
        toast.error("Error:", error.message);
      }
    }
  };
 
  return (
    <div>
      {loading ? (
        <p>Loading...</p>
      ) : roleData ? (
        <div>
          <Paper elevation={3} sx={{ p: 3, maxWidth: 1200 }}>
            <Typography variant="h5" gutterBottom>
              Update Role
            </Typography>
 
            <TextField
              value={roleData.role_name}
              label="Role Name"
              fullWidth
              onChange={(e) => {
                setRoleData(prev => ({
                  ...prev,
                  role_name: e.target.value
                }));
              }}
            />
            <Typography variant="h6" sx={{ mb: 2, mt: 3 }}>
              Module Access
            </Typography>
            <Box sx={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ textTransform: "capitalize", backgroundColor: '#f5f5f5' }}>
                    <th style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>Module</th>
                    {modules[0]?.permissions && Object.keys(modules[0].permissions).map(perm => (
                      <th key={perm} style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>
                        {perm}
                      </th>
                    ))}
                    <th style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>Select All</th>
                  </tr>
                </thead>
                <tbody>
                  {modules.map((module, moduleIndex) => (
                    <tr key={moduleIndex} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '12px', fontWeight: '500' }}>{module.name}</td>
                      {Object.keys(module.permissions).map((permission) => (
                        <td key={permission} style={{ padding: '12px', textAlign: 'center' }}>
                          <Checkbox
                            checked={module.permissions[permission] === true}
                            disabled={module.permissions[permission] === null}
                            onChange={() => handlePermissionChange(moduleIndex, permission)}
                            color="primary"
                          />
                        </td>
                      ))}
                      <td style={{ padding: '12px', textAlign: 'center' }}>
                        <Checkbox
                          checked={
                            Object.values(module.permissions)
                              .filter(p => p !== null)
                              .every(Boolean)
                          }
                          onChange={() => handleSelectAll(moduleIndex)}
                          style={{ color: "green" }}
                          indeterminate={
                            Object.values(module.permissions)
                              .filter(p => p !== null)
                              .some(Boolean) &&
                            !Object.values(module.permissions)
                              .filter(p => p !== null)
                              .every(Boolean)
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={!roleData.role_name.trim()}
              >
                Update Role
              </Button>
            </Box>
          </Paper>
        </div>
      ) : (
        <p>No data found.</p>
      )}
    </div>
  );
};
 
export default Editrolepage;
 